import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreDocument
} from '@angular/fire/firestore';
import { Observable, from } from 'rxjs';
import { UserDetails } from './user-details.model';
import { switchMap, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private firestore: AngularFirestore) {}

  public getUserDetails(
    user: firebase.User
  ): AngularFirestoreDocument<UserDetails> {
    return this.firestore.doc<UserDetails>(`users/${user.uid}`);
  }

  public getUserDetailsByKey(userKey: string): Observable<UserDetails> {
    return this.firestore.doc<UserDetails>(`users/${userKey}`).valueChanges();
  }

  public createUserDetailsRecord(
    user: firebase.User
  ): Observable<AngularFirestoreDocument<UserDetails>> {
    const model = this.createUserDetailsModel(user);
    return from(
      this.firestore
        .collection<UserDetails>('users')
        .doc(user.uid)
        .set({ ...model })
    ).pipe(map(() => this.getUserDetails(user)));
  }

  private createUserDetailsModel(user: firebase.User): UserDetails {
    const model = new UserDetails();
    const splitDisplayName = user.displayName.split(' ');
    model.lastName = splitDisplayName[splitDisplayName.length - 1];
    model.firstName = splitDisplayName
      .slice(0, splitDisplayName.length - 1)
      .join(' ');

    if (!!user.email && user.email.length > 0) {
      model.emailAddress = user.email;
    }

    if (!!user.phoneNumber && user.phoneNumber.length > 0) {
      model.phoneNumber = user.phoneNumber.substring(3);
    }

    model.profileComplete = false;

    return model;
  }
}
